import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const UserIcon: React.FC<SvgProps> = ({ strokeColor = '#CBD2D9' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9617 22.9062C22.6722 23.2613 23.4272 23.6608 24.1377 24.0603C25.3811 24.7261 26.8465 25.525 27.1574 25.7025C28.9337 26.679 29.3334 28.4544 29.3334 29.4753H2.60004C2.60004 28.4544 2.9997 26.7234 4.77601 25.7025C5.08686 25.525 6.55231 24.6817 7.79572 24.0603C9.03913 23.4389 9.30557 23.2613 10.0605 22.9062"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9616 22.9057C20.9402 23.9266 19.2083 24.9918 16.233 24.9918C13.2577 24.9918 11.1262 23.8822 10.1048 22.8613"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7856 18.0229C20.807 16.8689 22.2724 15.1378 22.8942 13.6731C23.4715 12.2084 24.0932 8.21372 22.1836 4.84043C20.2741 1.46714 17.3876 1.33398 16.1442 1.33398C14.9008 1.33398 11.659 2.04415 10.0604 4.84043C8.46171 7.63671 8.77256 12.2084 9.34986 13.6731C9.92716 15.1378 11.2594 16.8245 12.2808 17.9785"
      stroke={strokeColor}
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M12.9468 18.8672V21.1752C12.858 21.3972 11.6146 22.0629 10.1047 22.8619"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9615 12.385C21.9615 16.6904 19.075 19.6642 16.1886 19.6642C13.3021 19.6642 10.2823 16.646 10.2823 12.385C10.2823 8.124 16.5438 10.432 19.8744 6.74805C20.5849 10.4764 21.9615 11.0534 21.9615 12.385Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0749 18.8672V21.1752C19.1637 21.3972 20.4515 22.0629 21.9614 22.8619"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserIcon;
